import React, {Fragment, useCallback, useEffect, useRef, useState} from 'react'
import {DateRangePicker, Message, Pagination, ShowItemsSelect} from "../utilites";
import {useDispatch, useSelector} from "react-redux";
import {pageOptions, smsStatus, smsTypes, statusSms, typeSms} from "../../helpers/data-constants";
import {Link} from "react-router-dom";
import Loader from "./Loader";
import moment from "moment";
import _cloneDeep from "lodash/cloneDeep";
import Arrow from '../../assets/icons/arrow-down.svg';
import {getNotificationsListRequested} from "../../redux/actions/notificationAction"
import './notifications.scss'
import Select from "react-select";
import CrossSmallIcon from "../../assets/icons/cross-small.svg";
import {getFullNameDeal} from "../../redux/actions/clientsAction";

const Notifications = ({setTitlePage}) => {
    const [state, setState] = useState({
        typeDeal: [],
        events: [],
        statuses: [],
        fullName: [],
        timeRange: {
            startDate: null,
            endDate: null
        },
        processed: null,
        currentPage: 1,
        pageRange: pageOptions[0].value
    });

    const [sms, setSms] = useState([]);

    const {
        notificationsList: {sms: notifications, totalElements},
        loading,
        commonError
    } = useSelector(({notification}) => notification);
    const {clients} = useSelector(({handbook}) => handbook);
    const {accessFeatures, isLoadingConfiguration} = useSelector(({user}) => user);

    const dispatch = useDispatch();
    const departmentRef = useRef(null);
    const typeRef = useRef(null);
    const statusRef = useRef(null);

    useEffect(() => {
        accessFeatures['title.header_section'] && setTitlePage('Уведомления и СМС');
    }, [isLoadingConfiguration])

    useEffect(() => {
        const data = {
            startDate: state.timeRange.startDate ? state.timeRange.startDate.format("yyyy-MM-DD") : null,
            endDate: state.timeRange.endDate ? state.timeRange.endDate.format("yyyy-MM-DD") : null,
            clientId: null,
            type: null,
            status: null,
            page: state.currentPage,
            size: state.pageRange,
        }
        if (state.typeDeal && state.typeDeal.length > 0) {
            data.type = state.typeDeal.map(el => el.value).join(',')
        }
        if (state.statuses && state.statuses.length > 0) {
            data.status = state.statuses.map(el => el.value).join(',')
        }
        if (state.fullName && state.fullName.length > 0) {
            data.clientId = state.fullName.map(el => el.value).join(',')
        }
        dispatch(getNotificationsListRequested(data))
    }, [dispatch, state])

    useEffect(() => {
        if (notifications) {
            setSms(notifications);
        }
    }, [notifications]);

    const changeVisible = (id) => {
        let ind = sms.findIndex((item) => item.id === id);
        let newArray = _cloneDeep(sms);
        newArray[ind].isVisible = !sms[ind].isVisible;
        setSms(newArray);
    };

    const onTimeRangeChange = (timeRange) => {
        setState((prev) => ({
            ...prev,
            timeRange: timeRange,
            currentPage: 1
        }));
    }

    const onPageRangeChange = useCallback(({target: {value}}) => {
        setState((prev) => ({
            ...prev,
            pageRange: parseInt(value),
            currentPage: 1,
        }));
    }, []);

    const handlePageChange = useCallback((page) => {
        setState((prev) => ({
            ...prev,
            currentPage: page,
        }));
    }, []);

    const handleGetAction = (e, action) => {
        const {name} = action
        if (action.action === 'input-change' && name === 'fullName') {
            const data = {
                size: 5,
                page: 1,
                sortBy: 'fullName',
                name: e,
                filters: {
                    // status: searchStatus.join(','),
                },
            }
            dispatch(getFullNameDeal(data))
        }
    }

    const chooseFullName = (fullName) => {
        if (fullName && Array.isArray(state.fullName)) {
            if (!state.fullName.find(({value}) => value === fullName.value)) {
                const newArrDepartments = [...state.fullName];
                newArrDepartments.push(fullName);

                setState((prev) => ({
                    ...prev,
                    fullName: newArrDepartments,
                    currentPage: 1
                }));
            }
        }
    };

    const renderFasets = (facets) => {
        return (
            facets?.length !== 0 &&
            facets?.map((i) => {
                return (
                    <button
                        type="button"
                        className="search-facet"
                        key={i.value}
                        onClick={() => deleteChoice(i.value, i.action)}
                        id="button">
            <span htmlFor="button" className={'not-crossed'}>
              {i.label}
            </span>
                    </button>
                );
            })
        );
    };

    const deleteItem = (stateKey, value) => {
        const filteredArr = state[stateKey].filter((i) => i.value !== value);

        setState((prev) => ({
            ...prev,
            [stateKey]: filteredArr,
            currentPage: 1
        }));
    };

    const deleteChoice = (value, action) => {
        switch (action) {
            case 'fullName':
                deleteItem('fullName', value);
                break;
            case 'statusSms':
                deleteItem('statuses', value);
                break;
            case 'typeSms':
                deleteItem('typeDeal', value);
                break;
            default:
                break;
        }
    };

    const handleTypeDeal = (typeDeal) => {
        if (typeDeal && Array.isArray(state.typeDeal)) {
            if (!state.typeDeal.find(({value}) => value === typeDeal.value)) {
                const newArrTypesDeal = [...state.typeDeal]
                newArrTypesDeal.push({value: typeDeal.value, label: typeDeal.label, action: typeDeal.action})

                setState({
                    ...state,
                    typeDeal: newArrTypesDeal,
                    currentPage: 1
                })
            }
        }
    }

    const handleStatusDeal = (status) => {
        if (status && Array.isArray(state.statuses)) {
            if (!state.statuses.find(({value}) => value === status.value)) {
                const newArrTypesDeal = [...state.statuses]
                newArrTypesDeal.push({value: status.value, label: status.label, action: status.action})

                setState({
                    ...state,
                    statuses: newArrTypesDeal,
                    currentPage: 1
                })
            }
        }
    }

    const handleReset = () => {
        setState((prev) => ({
            ...prev,
            fullName: [],
            statuses: [],
            typeDeal: [],
            timeRange: {
                startDate: null,
                endDate: null
            },
            currentPage: 1
        }));

        departmentRef.current.select.clearValue();
        typeRef.current.select.clearValue();
        statusRef.current.select.clearValue();
    };

    return (<main className="app-content">
        {isLoadingConfiguration ?
            (<div className="content-inner">
                <Loader pageRange={1}/>
            </div>) :
            (<>
                {!accessFeatures['title.header_section'] &&
                    (<div className="content-header">
                            <h1>Уведомления и СМС</h1>
                        </div>
                    )}
                <div className="content-inner">
                    <div className="content-inner-data notifications-inner-data">
                        <div className="content-datatable-header">
                            <div className="d-flex flex-column align-center m-l-auto m-r-auto">
                                <div className="content-datatable-header-actions d-flex">
                                    <div className="content-datatable-header-center notifications-searcgFacets">
                                        <div className="action-items notifications-searchItems">
                                            {accessFeatures['sms.search'] && (
                                                <>
                                                    {accessFeatures['sms.search'] && (
                                                        <>
                                                            <Select
                                                                ref={departmentRef}
                                                                classNamePrefix="select"
                                                                className="basic-multi-select overdue-searchItem"
                                                                placeholder="Введите ФИО"
                                                                isLoading={loading}
                                                                options={clients}
                                                                noOptionsMessage={() => 'Нет результатов'}
                                                                loadingMessage={() => 'Загрузка...'}
                                                                onInputChange={(value, action) =>
                                                                    handleGetAction(value, {
                                                                        ...action,
                                                                        name: 'fullName'
                                                                    })
                                                                }
                                                                onChange={chooseFullName}
                                                            />
                                                            <Select
                                                                ref={typeRef}
                                                                classNamePrefix="select"
                                                                className="overdue-searchItem"
                                                                placeholder="Введите тип СМС"
                                                                isLoading={loading}
                                                                options={typeSms}
                                                                noOptionsMessage={() => 'Нет результатов'}
                                                                loadingMessage={() => 'Загрузка...'}
                                                                onChange={handleTypeDeal}
                                                            />
                                                            <Select
                                                                ref={statusRef}
                                                                classNamePrefix="select"
                                                                className="overdue-searchItem"
                                                                placeholder="Введите статус СМС"
                                                                isLoading={loading}
                                                                options={statusSms}
                                                                noOptionsMessage={() => 'Нет результатов'}
                                                                loadingMessage={() => 'Загрузка...'}
                                                                onChange={handleStatusDeal}/>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                            <DateRangePicker
                                                coverClass={'form-element'}
                                                startDate={state.timeRange.startDate}
                                                endDate={state.timeRange.endDate}
                                                onChange={(v) => onTimeRangeChange(v)}
                                            />
                                        </div>
                                        <div className="notifications-searchFacets">
                                            {
                                                state.fullName.length ?
                                                    <div className="search-facets-pillboxes overdue-facet">
                                                        <h4 className='overdue-titleFacets'>ФИО клиента:</h4>
                                                        {renderFasets(state.fullName)}
                                                    </div> : null
                                            }
                                            {
                                                state.typeDeal.length ?
                                                    <div className="search-facets-pillboxes overdue-facet">
                                                        <h4 className='overdue-titleFacets'>Тип:</h4>
                                                        {renderFasets(state.typeDeal)}
                                                    </div> : null
                                            }
                                            {
                                                state.statuses.length ?
                                                    <div className="search-facets-pillboxes overdue-facet">
                                                        <h4 className='overdue-titleFacets'>Статус:</h4>
                                                        {renderFasets(state.statuses)}
                                                    </div> : null
                                            }
                                        </div>
                                        <div className="search-facets-actions overdue-resetAll">
                                            <button className="button-icontrigger noborder" onClick={handleReset}>
                      <span className="icon">
                        <CrossSmallIcon/>
                      </span>
                                                <span>Сбросить</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="content-inner-data-container">
                            {commonError && <Message type="error" text={commonError}/>}
                            <div className="content-datatable">
                                <div className="content-datatable-header ">
                                    <div className="content-datatable-header-right">
                                        <ShowItemsSelect
                                            options={pageOptions}
                                            change={onPageRangeChange}
                                            wrapClass={'padding-select'}
                                        />
                                    </div>
                                </div>
                                <div className="content-datatable-content">
                                    {loading ? (
                                        <Loader pageRange={state.pageRange}/>
                                    ) : (
                                        <table className="table notifications-table">
                                            <thead>
                                            <tr>
                                                <th scope="col">
                                                    <p>Договор</p>
                                                </th>
                                                <th scope="col">
                                                    <p>Дата/Время</p>
                                                </th>
                                                <th scope="col">
                                                    <p>Клиент</p>
                                                </th>
                                                <th scope="col">
                                                    <p>Тип</p>
                                                </th>
                                                <th scope="col">
                                                    <p>Статус</p>
                                                </th>
                                                <th scope="col"/>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {sms && sms.length > 0 && sms.map(message => {
                                                return (
                                                    <Fragment key={message.id}>
                                                        <tr className="notifications-table-row__hover">
                                                            <td>
                                                                <div className="table-cellcontent">
                                                                    <p>{message.dealId !== -1 &&
                                                                        <Link
                                                                            className="table-link"
                                                                            to={`client/${message.clientId}/contracts/${message.dealId}`}>
                                                                            <span>{message.dealNumber}</span>
                                                                        </Link>}
                                                                    </p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="table-cellcontent">
                                                                    <p>{moment(message.date).format('DD.MM.YYYY, HH:mm:ss')}</p>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="table-cellcontent">
                                                                    <Link
                                                                        className="table-link"
                                                                        to={`client/${message.clientId}`}>
                                                                        <span>{message.clientFullName}</span>
                                                                    </Link>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <p>{smsTypes[message.type || "UNKNOWN"] || smsTypes["UNKNOWN"]}</p>
                                                            </td>
                                                            <td>
                                                                <span className="caption">Статус</span>
                                                                <p>
                                <span
                                    className={smsStatus[message.status]?.label ? "label " + smsStatus[message.status].label : "label " + smsStatus["UNKNOWN"].label}>
                                  {smsStatus[message.status]?.text ? smsStatus[message.status].text : smsStatus["UNKNOWN"].text}
                                </span>
                                                                </p>
                                                            </td>
                                                            <td
                                                                className={`notifications-table-col-arrow${message.isVisible ? '-up' : ''}`}>
                                                                <Arrow onClick={() => changeVisible(message.id)}/>
                                                            </td>
                                                        </tr>
                                                        {message.isVisible &&
                                                            <tr
                                                                className={`notifications-table-line${message.isVisible ? '-visible' : ''}`}>
                                                                <td></td>
                                                                <td colSpan={2}>
                                                                    <div
                                                                        className='notifications-details notifications-details__t'>
                                                                        <span
                                                                            className='notifications-details-message-title'>Текст соообщения:</span>
                                                                        <div
                                                                            className='notifications-details-message'>{message.messageText}</div>
                                                                    </div>
                                                                </td>
                                                                <td colSpan={2}>
                                                                    <div className='notifications-details'>
                                                                        <div
                                                                            className='notifications-details-title'>Оператор:
                                                                        </div>
                                                                        <div>{message.userFullName || 'Отправитель не найден'}</div>
                                                                    </div>
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        }
                                                    </Fragment>
                                                );
                                            })}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                            <Pagination
                                total={Math.ceil(totalElements / state.pageRange)}
                                current={state.currentPage}
                                handlePageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </div>
            </>)
        }
    </main>)
}

export default Notifications
